import * as localeKO from "./ko";
import * as localeZh from "./zh";

export const ko = { ...localeKO };
export const zh = { ...localeZh };

const locales = { ko, zh };

export default locales;
